export const config = {
  moralis: {
    serverUrl: process.env.REACT_APP_MORALIS_SERVER_URL,
    appId: process.env.REACT_APP_MORALIS_APP_ID
  },
  cryptoServiceUrl: process.env.REACT_APP_CRYPTO_SERVICE_URL
}
